// @ts-nocheck

import { lazy } from 'react';
export const EditSettingsScreenAsync = lazy(
  () => import('./EditSettingsScreen.tsx'),
);
